/**
 * Agentforce explore filter: user-facing URL uses `tools` / `subagents`;
 * app state and search API continue to use `actions` / `topics`.
 */

/** URL query param tokens (public-facing) */
export const AGENTIC_CONTENT_URL_TOOLS = 'actions';
export const AGENTIC_CONTENT_URL_SUBAGENTS = 'subagents';

/** API / internal filter values (unchanged for backend) */
export const AGENTIC_CONTENT_API_ACTIONS = 'actions';
export const AGENTIC_CONTENT_API_TOPICS = 'topics';

const URL_TOKEN_TO_API: Record<string, string> = {
    [AGENTIC_CONTENT_URL_TOOLS]: AGENTIC_CONTENT_API_ACTIONS,
    [AGENTIC_CONTENT_URL_SUBAGENTS]: AGENTIC_CONTENT_API_TOPICS,
};

const API_VALUE_TO_URL: Record<string, string> = {
    [AGENTIC_CONTENT_API_ACTIONS]: AGENTIC_CONTENT_URL_TOOLS,
    [AGENTIC_CONTENT_API_TOPICS]: AGENTIC_CONTENT_URL_SUBAGENTS,
};

/**
 * Map URL param values to internal/API values after parsing the route.
 */
export function normalizeAgenticContentFromUrl(values: string[] | undefined): string[] | undefined {
    if (!values?.length) {
        return values;
    }
    return values.map((v) => URL_TOKEN_TO_API[v] ?? v);
}

/**
 * Map internal/API values to URL param values when building query strings.
 */
export function agenticContentForUrl(values: string[] | undefined): string[] | undefined {
    if (!values?.length) {
        return values;
    }
    return values.map((v) => API_VALUE_TO_URL[v] ?? v);
}
